import React from "react"
import { FormattedMessage } from "react-intl"

import { Body, Button, Display } from "@walmart-web/livingdesign-components"
import unexpectedErrorImage from "assets/images/error/unexpected_error.svg"
import "./index.scss"
import { ErrorProps } from "./interfaces"
import withVisibility from "../Hocs/withVisibility/withVisibility"

const DisplayError: React.FC<ErrorProps> = ({
	error,
	img,
	hasRetry = false,
	descriptionRetryButton = "",
	actionRetryButton = () => {},
}) => {
	const renderRetryButton = () => {
		return (
			<Button
				role="retry-button"
				size="medium"
				variant="primary"
				onClick={() => actionRetryButton()}
				data-testid="retry-button"
				className="display-error-button"
			>
				{descriptionRetryButton}
			</Button>
		)
	}

	const renderOptionalMessageDescription = () =>
		error.message && (
			<Body as="p">
				<FormattedMessage id={error.message} />
			</Body>
		)
	return (
		<div role="alert" className="display-error-container">
			<div className="display-error-image-container">
				<img alt="Error image" src={img ? img : unexpectedErrorImage} />
			</div>
			<div className="display-error-body">
				<Display variant="2">
					<FormattedMessage id={error.name} />
				</Display>
				{renderOptionalMessageDescription()}
				{hasRetry && renderRetryButton()}
			</div>
		</div>
	)
}

export default withVisibility(DisplayError)
